/* eslint-disable react/no-array-index-key */
import React, { useContext, useMemo } from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import { Text } from '@bingads-webui-react/fabric-control';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { PropertyRow } from '@bingads-webui-campaign-react/ui-generator';
import { getDay, getMin, getTime, minuteToSaveMap, } from '@bingads-webui-campaign-react/wizard-shared-components';

export const getDayTimeDetails = (i18n, dayTime, is12) => {
  const startHour = dayTime.StartHour;
  const endHour = dayTime.EndHour;
  const startMin = getMin(minuteToSaveMap[dayTime.StartMinute]);
  const endMin = getMin(minuteToSaveMap[dayTime.EndMinute]);
  const dateTimePart = `${i18n.getString(getDay(dayTime.Day))}, ${i18n.getString(_TL_('{{from}} - {{to}}'), {
    from: i18n.getString(getTime(startHour, is12), { min: startMin }),
    to: i18n.getString(getTime(endHour, is12), { min: endMin }),
  })}`;

  return `${dateTimePart}: ${dayTime.BidAdjustmentType > 0 ? i18n.getString(_TL_('Increase by')) : i18n.getString(_TL_('Decrease by'))}
  ${dayTime.BidAdjustmentAmount || 0}%`;
};

const getAdScheduleDetails = (i18n, adSchedules, timeDisplayType, useSearcherTimeZone) => {
  const details = [];

  const is12 = timeDisplayType === '12-hour';
  const len = (adSchedules && adSchedules.length) || 0;

  if (len === 0) {
    const defaultSchedule = {
      Id: '',
      Day: 'Alldays',
      StartHour: 0,
      StartMinute: 'ZERO',
      EndHour: 24,
      EndMinute: 'ZERO',
      BidAdjustmentType: 1,
      BidAdjustmentAmount: 0,
      CashbackPercent: null,
    };

    details.push(getDayTimeDetails(i18n, defaultSchedule, is12));
  } else {
    _.forEach(adSchedules, (schedule) => {
      details.push(getDayTimeDetails(i18n, schedule, is12));
    });
  }

  if (useSearcherTimeZone) {
    details.push(i18n.getString(_TL_('In ad viewer\'s time zone')));
  } else {
    details.push(i18n.getString(_TL_('In your account\'s time zone')));
  }

  return details;
};

export const AdScheduleWithBidAdjustments = ({
  adSchedules, useSearcherTimeZone, timeDisplayType,
}) => {
  const i18n = useContext(I18nContext);

  const adScheduleSettings = useMemo(
    () => (getAdScheduleDetails(i18n, adSchedules, timeDisplayType, useSearcherTimeZone))
    , [adSchedules, i18n, timeDisplayType, useSearcherTimeZone]
  );

  return (
    <PropertyRow propertyLabel={{ label: _TL_('Ad schedule') }}>
      {adScheduleSettings.map((schedule, index) => (
        <Text block key={index}>{schedule}</Text>
      ))}
    </PropertyRow>
  );
};

AdScheduleWithBidAdjustments.propTypes = {
  adSchedules: PropTypes.arrayOf(PropTypes.shape({})),
  useSearcherTimeZone: PropTypes.bool,
  timeDisplayType: PropTypes.string,
};

AdScheduleWithBidAdjustments.defaultProps = {
  adSchedules: null,
  useSearcherTimeZone: false,
  timeDisplayType: '12-hour',
};
